var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrollToTopBar"},[_c('tk-link',{on:{"click":_vm.scrollToTop}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }